import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaHandshake, FaRocket } from "react-icons/fa";

function HowItWorks() {
  const steps = [
    {
      title: "Get in Touch",
      description:
        "Reach out to us via phone, email, or our website. Share your requirements and let us know how we can assist you.",
      icon: <FaPhoneAlt />,
    },
    {
      title: "Consultation",
      description:
        "Our financial expert will have a detailed discussion with you to understand your specific needs, goals, and financial situation.",
      icon: <FaHandshake />,
    },
    {
      title: "Get Started",
      description:
        "Complete the simple onboarding process with the guidance of our team and embark on your journey towards financial success.",
      icon: <FaRocket />,
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Increased stagger time
      },
    },
  };

  const stepVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  };

  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-gray-50 px-4 md:px-8">
      <div className="container mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            How It Works
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Simple steps to get started with Keziah's financial services and
            achieve your financial goals.
          </p>
        </div>
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="text-center flex flex-col items-center"
              variants={stepVariants}
            >
              <div className="w-20 h-20 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mb-6 shadow-md transition duration-500 ease-in-out transform hover:bg-blue-600 hover:text-white hover:-translate-y-2">
                <span className="text-3xl">{step.icon}</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 text-lg">{step.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default HowItWorks;